import { render, staticRenderFns } from "./workCalendar.vue?vue&type=template&id=520bf034&scoped=true"
import script from "./workCalendar.vue?vue&type=script&lang=js"
export * from "./workCalendar.vue?vue&type=script&lang=js"
import style0 from "./workCalendar.vue?vue&type=style&index=0&id=520bf034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520bf034",
  null
  
)

export default component.exports